export const MAX_LINE = 100;
export const MAX_LENGTH = 100;
